/*
interface KitoCardProps {
    title: string;
    subtitle: string;
    image: string;
    children: ReactNode;
    width?: number;
    color: "yellow" | "blue" | "blue-green" | "orange" | "red";
}
*/
import clsx from 'clsx';

import './styles.css';

function KitoCard({
  color,
  short,
  width,
  fullWidth,
  marginBottom,
  image,
  children,
  title,
  subtitle,
  onClick,
  disabled,
  ...rest
}) {
  const click = (e) => {
    e.stopPropagation();
    if (disabled) return;
    onClick && onClick();
  };
  return (
    <div
      className={clsx(
        'kito-card',
        color && `kito-card__${color}`,
        short && 'kito-card__short',
        fullWidth && 'kito-card__full-width',
        onClick && !disabled && 'kito-card__clickable',
        disabled && 'kito-card__disabled',
      )}
      style={{
        '--kito-card-width': `${width || 280}px`,
        '--kito-card-width__small': `${width || 240}px`,
        ...rest,
      }}
      aria-disabled={disabled || undefined}
      onClick={click}
    >
      <div className="kito-card__content">
        <img src={image} alt="kito-card-image" className="kito-card__image" />
        <div className="kito-card__data">
          <div>
            <h4 className="kito-card__title">{title}</h4>
            <p className="kito-card__subtitle">{subtitle}</p>
          </div>
          {!short && children}
        </div>
      </div>
    </div>
  );
}

export default KitoCard;
